import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IConfigState {
  isMobile: Boolean;
  isStandalone: Boolean;
}

const initialState: IConfigState = {
  isMobile: false,
  isStandalone: false,
};

export const configSlice = createSlice({
  initialState,
  name: 'configSlice',
  reducers: {
    logout: () => initialState,
    setIsMobile: (state, action: PayloadAction<Boolean>) => {
      state.isMobile = action.payload;
    },
    setIsStandalone: (state, action: PayloadAction<Boolean>) => {
      state.isStandalone = action.payload;
    },
  },
});

export default configSlice.reducer;

export const { logout, setIsMobile, setIsStandalone } = configSlice.actions;
